import { usePOSStore } from '../stores/posStore';

export default function Header(): JSX.Element {
  const getCartItemCount = usePOSStore((state) => state.getCartItemCount);
  const isOnline = usePOSStore((state) => state.isOnline);

  return (
    <header className="sticky top-0 z-10 bg-white border-b border-gray-200 shadow-sm">
      <div className="px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <h1 className="text-xl font-bold text-gray-900">WebWaka POS</h1>
          <div className={`w-2 h-2 rounded-full ${isOnline ? 'bg-green-500' : 'bg-red-500'}`} />
        </div>
        <div className="text-sm text-gray-600">{isOnline ? 'Online' : 'Offline'}</div>
      </div>
      <div className="px-4 py-2 bg-gray-50 text-sm text-gray-700">
        Items in cart: {getCartItemCount()}
      </div>
    </header>
  );
}
